import React, { useState, useEffect } from 'react';
import { authFetch } from '../services/api';
import './IntegrationApplicationMasterData.css';

interface IntegrationStats {
  totalApplications: number;
  distribution: {
    'Retire': number;
    'Re-Platform': number;
    'Re-Design': number;
    'Retain': number;
  };
}

const Integration: React.FC = () => {
  const [stats, setStats] = useState<IntegrationStats>({
    totalApplications: 0,
    distribution: { 'Retire': 0, 'Re-Platform': 0, 'Re-Design': 0, 'Retain': 0 }
  });
  const [loading, setLoading] = useState(true);

  const loadStats = async () => {
    setLoading(true);
    try {
      // Use server-provided stats from applications-master (single lightweight call)
      const response = await authFetch('/api/applications-master?limit=1');
      if (response.ok) {
        const data = await response.json();
        if (data.success && data.stats) {
          setStats({
            totalApplications: data.stats.totalApplications || 0,
            distribution: {
              'Retire': data.stats.distribution?.['Retire'] || 0,
              'Re-Platform': data.stats.distribution?.['Re-Platform'] || 0,
              'Re-Design': data.stats.distribution?.['Re-Design'] || 0,
              'Retain': data.stats.distribution?.['Retain'] || 0,
            }
          });
        }
      }
    } catch (error) {
      console.error('Error loading integration stats:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStats();
  }, []);

  return (
    <div className="page">
      {/* Header */}
      <div className="page-header">
        <div className="page-header__content">
          <div className="page-header__title-section">
            <h1 className="page-header__title">Integration Framework</h1>
            <p className="page-header__subtitle">
              Overview and management of application integration ecosystem
            </p>
          </div>
          <div className="page-header__actions">
          </div>
        </div>
      </div>

      {/* Main Content Container */}
      <div className="master-data-container">

      {/* Application Portfolio Statistics */}
      <div className="md-card">
        <div className="md-card-content">
          <h2 style={{ marginBottom: '24px', color: '#1976d2' }}>📊 Application Portfolio Distribution</h2>
          <div className="md-stats-grid">
            <div className="md-card md-card--elevated">
              <div className="md-card-content">
                <div className="md-stat-primary" style={{ color: '#dc2626' }}>
                  {stats.distribution['Retire']}
                </div>
                <div className="md-stat-label" style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>🗑️ Retire</div>
              </div>
            </div>
            
            <div className="md-card md-card--elevated">
              <div className="md-card-content">
                <div className="md-stat-primary" style={{ color: '#f59e0b' }}>
                  {stats.distribution['Re-Platform']}
                </div>
                <div className="md-stat-label" style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>🔄 Re-Platform</div>
              </div>
            </div>
            
            <div className="md-card md-card--elevated">
              <div className="md-card-content">
                <div className="md-stat-primary" style={{ color: '#3b82f6' }}>
                  {stats.distribution['Re-Design']}
                </div>
                <div className="md-stat-label" style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>🎨 Re-Design</div>
              </div>
            </div>
            
            <div className="md-card md-card--elevated">
              <div className="md-card-content">
                <div className="md-stat-primary" style={{ color: '#10b981' }}>
                  {stats.distribution['Retain']}
                </div>
                <div className="md-stat-label" style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>✅ Retain</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {loading && (
        <div className="md-loading-state">
          <div className="md-spinner"></div>
          <h3>Loading Integration Framework Data</h3>
          <p>Please wait while we fetch the latest integration statistics...</p>
        </div>
      )}
      </div>
    </div>
  );
};

export default Integration;